import styled from 'styled-components'

export const StyledWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
  position: absolute;
  right: 15px;
  top: 25px;
`

export const StyledBalanceLabel = styled.div`
  color: ${({ theme }) => theme.colors.primary};
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0.2px;
  line-height: 16px;
`

export const StyledMaxButton = styled.button`
  background: ${({ theme }) => theme.colors.primaryMuted};
  border: none;
  border-radius: 20px;
  color: ${({ theme }) => theme.colors.primary};
  cursor: pointer;
  font-weight: 500;
  font-size: 10px;
  letter-spacing: 0.2px;
  line-height: 16px;
  margin-left: 10px;
  outline: none;
  padding: 1px 4px;
`
